
import { z } from "zod";

export const formSchema = z.object({
  metal: z.enum(["gold", "silver"], {
    required_error: "Seleziona un metallo",
  }),
  targetPrice: z.coerce.number({
    required_error: "Inserisci un prezzo obiettivo",
    invalid_type_error: "Inserisci un numero valido",
  }).positive("Il prezzo deve essere positivo"),
  condition: z.enum(["above", "below"], {
    required_error: "Seleziona una condizione",
  }),
});

export type FormValues = z.infer<typeof formSchema>;
